import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import {
  Checkbox,
  Text
} from '@chakra-ui/react'

import branding from '@/branding'
import AmModal from '@/components/organisms/Modals/AmModal'
import AmModalTermsAndConditions from '@/components/organisms/Modals/AmModalTermsAndConditions'
import i18n from '@/i18n'
import { userSettings } from '@/redux/user/selectors'
import { LegalConsentValues } from '@/types'

interface Props {
  changeValues: (values: LegalConsentValues) => void
}

const AmModalLegalConsent: FC<Props> = ({ changeValues }) => {
  const currentUserSettings = useSelector(userSettings)

  const [termsAndConditions, setTermsAndConditions] = useState(false)
  const [privacyPolicy, setPrivacyPolicy] = useState(false)
  const [tcPdfOpened, setTcPdfOpened] = useState(false)

  useEffect(() => {
    setTermsAndConditions(
      currentUserSettings?.termAndConditionsAccepted || false
    )
    setPrivacyPolicy(currentUserSettings?.privacyPolicyAccepted || false)
  }, [currentUserSettings])

  const { t } = useTranslation()

  function handleConfirm () {
    changeValues({
      termAndConditionsAccepted: termsAndConditions,
      privacyPolicyAccepted: privacyPolicy
    })
  }

  function handleTcPdfOpenedClick (e: React.MouseEvent<HTMLAnchorElement>) {
    e.preventDefault()
    setTcPdfOpened(true)
  }

  return (
    <>
      <AmModal
        open={true}
        onClose={() => {
        }}
        title={t('gui.general.legal_checkboxes_title')}
        showCloseButton={false}
        size='md'
        primaryBtnProps={{
          children: t('gui.buttons.confirm'),
          onClick: handleConfirm
        }}
      >
        <Text mb={4}>{t('gui.general.legal_checkboxes_intro')}</Text>
        <Checkbox
          isChecked={termsAndConditions}
          onChange={() => setTermsAndConditions(!termsAndConditions)}
          alignItems='center'
        >
          <Text textAlign='left' size='sm' mt='5px'>
            {t('gui.general.read_and_accept')}{' '}
            <a
              style={{
                textDecoration: 'underline',
                color: '#F36159'
              }}
              href={branding.legalLinks?.terms}
              target={branding.legalLinks ? '_blank' : undefined}
              rel={branding.legalLinks ? 'noopener noreferrer' : undefined}
              onClick={branding.legalLinks ? undefined : handleTcPdfOpenedClick}
            >
              {t('gui.general.terms_conditions')}
            </a>
          </Text>
        </Checkbox>
        <Checkbox
          isChecked={privacyPolicy}
          onChange={() => setPrivacyPolicy(!privacyPolicy)}
          alignItems='center'
        >
          <Text textAlign='left' size='sm' mt='5px'>
            {t('gui.general.read_and_accept')}{' '}
            <a
              href={branding.legalLinks?.privacy ??
                `https://legal.allimb.com/privacy-policy/${i18n.resolvedLanguage === 'en' ? 'eng' : 'ita'}/`}
              target={branding.legalLinks ? '_blank' : undefined}
              rel={branding.legalLinks ? 'noopener noreferrer' : undefined}
              style={{ textDecoration: 'underline', color: '#F36159' }}
            >
              {t('gui.general.privacy_policy')}
            </a>
          </Text>
        </Checkbox>
        {(!termsAndConditions || !privacyPolicy) && (
          <Text color='red' fontSize='sm' mt={4}>
            {t('gui.general.legal_checkboxes_error')}
          </Text>
        )}
      </AmModal>

      <AmModalTermsAndConditions
        isOpen={tcPdfOpened}
        onClose={() => setTcPdfOpened(false)}
      />
    </>
  )
}

export default AmModalLegalConsent
